import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import qs from 'qs'

export const useSyncUrlState = state => {
    const history = useHistory()

    useEffect(() => {
        history.replace(location.pathname + searchStateToUrl(state), state)
    }, [state])

    return {
        urlToSearchState
    }
}

export const createURL = state =>
    `?${qs.stringify(state, {
        skipNulls: true,
        filter(prefix, value) {
            if (value === false) {
                return 'false'
            }
            if (value == '') {
                return
            }
            return value
        }
    })}`

const searchStateToUrl = searchState =>
    searchState ? createURL(searchState) : ''

export const urlToSearchState = ({ search }) =>
    qs.parse(search.slice(1), {
        decoder(str, decoder, charset) {
            const strWithoutPlus = str.replace(/\+/g, ' ')
            if (charset === 'iso-8859-1') {
                // unescape never throws, no try...catch needed:
                return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape)
            }

            if (/^(\d+|\d*\.\d+)$/.test(str)) {
                return parseFloat(str)
            }

            const keywords = {
                true: true,
                false: false,
                null: null,
                undefined
            }
            if (str in keywords) {
                return keywords[str]
            }

            // utf-8
            try {
                return decodeURIComponent(strWithoutPlus)
            } catch (e) {
                return strWithoutPlus
            }
        }
    })
